import request from './services/axios.js'

export default {
  isLockTypeSet: () => {
    return request({
      url: '/base/switch.do',
      method: 'post'
    })
  }
}
